import React from 'react';
import './Header.css'

function Header (){
    return(
        <section className="header">
            <section className="logo">Code Editor <a href="https://github.com/muhaiminrahim" target="_blank" rel="noopener noreferrer">by @muhaiminrahim</a></section>
        </section>
    )
}

export default Header;